export enum SyncStatus {
    NEW = "NEW",
    UPDATED = "UPDATED",
    DELETED = "DELETED",
}

export enum GenerationStatus {
    EMPTY = "EMPTY",
    NEW = "NEW",
    BLOCKED = "BLOCKED",
    APPROVED = "APPROVED",
    OUTDATED = "OUTDATED",
    GENERATED = "GENERATED",
    FAILED = "FAILED",
    GENERATING = "GENERATING"
}

export enum JobStatus {
    PENDING = "PENDING",
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETED = "COMPLETED",
    FAILED = "FAILED",
    PARTIAL_SUCCESS = "PARTIAL_SUCCESS",
    CANCELLED = "CANCELLED",
}
